import { useCallback } from 'react';
import webCore from '@happylife-a/web-core';
import { useAppLocale } from '../contexts';
import * as helpers from '../helpers';

// @INFO: set the default value of removeDefaultLocale
export const REMOVE_DEFAULT_LOCALE = false;

function useLocalizedUrlBuilder(removeDefaultLocale = REMOVE_DEFAULT_LOCALE) {
  const { initialPrefix } = useAppLocale();
  const { available, locale: currentLocale, defaultLocale } = webCore.contexts.useTranslation();

  const buildNewUrl = useCallback(
    (domain, url, newLocale = null) => {
      const locale = newLocale || currentLocale;
      const prefix = initialPrefix || '';
      const pattern = new RegExp(`^/(${available.join('|')})`);
      const parsedUrl = url.replace(pattern, '').replace(/^\/$/, '');

      const isWithoutLocale = removeDefaultLocale || defaultLocale === locale;
      const parts = [prefix, isWithoutLocale ? null : locale, parsedUrl];
      let finalUrl = helpers.url.buildUrlFromParts(parts);

      // Ensure at least '/' for empty URLs
      if (!finalUrl || finalUrl === '') {
        finalUrl = '/';
      }

      if (typeof domain === 'string') {
        if (finalUrl.startsWith('/')) {
          finalUrl = finalUrl.substring(1);
        }
        if (domain.endsWith('/')) {
          domain = domain.substring(0, domain.length - 1);
        }
        finalUrl = `${domain}/${finalUrl}`;
      }

      return finalUrl;
    },
    [removeDefaultLocale, currentLocale]
  );

  return buildNewUrl;
}

export default useLocalizedUrlBuilder;
